var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.hasModule
    ? _c("app-missing-module-modal", {
        attrs: { "module-id": _vm.requiredModuleId },
        on: {
          close: function ($event) {
            return _vm.close()
          },
        },
      })
    : _vm.step == 1
    ? _c("app-coda-upload", {
        attrs: { "edit-bank-id": _vm.bankId },
        on: {
          close: function ($event) {
            return _vm.close()
          },
          result: _vm.onResult,
        },
      })
    : _c("app-coda-preview", {
        attrs: { items: _vm.banks },
        on: {
          close: function ($event) {
            return _vm.close()
          },
          done: function ($event) {
            return _vm.done()
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }